module.exports = __webpack_public_path__ + "static/20-2ca8371fd5a8a797350cf8c3ff621c7e.png";